/* BVN (26/10/2026) : recherche instantanée en panneau (snippets/bvn-search.liquid).
   - S'ouvre sans changer de page : onglet « Recherche » de la barre du bas, loupe de l'en-tête, [data-bvs-open].
   - Suggestions pendant la saisie : section bvn-predictive (prix dans la devise du visiteur, liens localisés).
   - Échap, bouton Annuler ou fond sombre ferment le panneau (pas d'entrée d'historique : InstantClick gère déjà l'historique).
   - Le site recharge des pages sans rechargement complet (InstantClick) : tout passe par délégation sur document. */
(function () {
  'use strict';
  if (window.__bvs) return;
  window.__bvs = true;

  var MIN = 2, DELAY = 180, KEY = 'bvs_recent';
  var timer = null, ctrl = null, cache = {}, lastFocus = null;

  function root() { return document.getElementById('bvs'); }
  function q(sel, el) { return (el || root()).querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Recherches récentes (facultatif : stockage local du navigateur) ---------- */
  function getRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]').slice(0, 6); } catch (e) { return []; } }
  function addRecent(t) {
    t = String(t || '').trim(); if (t.length < MIN) return;
    try { var r = getRecent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); }); r.unshift(t); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 6))); } catch (e) {}
  }
  function drawRecent() {
    var box = q('[data-bvs-recent]'), list = q('[data-bvs-recent-list]'), r = getRecent();
    if (!box || !list) return;
    box.hidden = !r.length;
    var base = root().getAttribute('data-search');
    list.innerHTML = r.map(function (t) {
      return '<a class="bvs-chip bvs-chip--recent" href="' + base + '?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last&type=product" data-bvs-term="' + esc(t) + '">' + esc(t) + '</a>';
    }).join('');
  }

  /* ---------- Ouverture / fermeture ---------- */
  function isOpen() { var r = root(); return !!(r && !r.hidden); }
  function open(prefill) {
    var r = root(); if (!r) return false;
    lastFocus = document.activeElement;
    r.hidden = false;
    document.documentElement.classList.add('bvs-lock');
    var input = q('[data-bvs-input]');
    if (prefill != null) input.value = prefill;
    drawRecent();
    sync();
    /* Le focus doit partir dans le même geste que le toucher, sinon iOS n'ouvre pas le clavier. */
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    void r.offsetWidth; /* recalcul du style : l'animation d'ouverture part sans attendre une image (rAF est suspendu en arrière-plan) */
    r.classList.add('is-open');
    return true;
  }
  function close() {
    var r = root(); if (!r || r.hidden) return;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('bvs-lock');
    var input = q('[data-bvs-input]'); if (input) input.blur();
    setTimeout(function () { if (!r.classList.contains('is-open')) r.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.addEventListener('popstate', function () { if (isOpen()) close(); });
  /* Page suivante chargée par InstantClick : le panneau disparaît avec l'ancienne page, on libère le défilement. */
  function unlock() { document.documentElement.classList.remove('bvs-lock'); }
  if (window.InstantClick && InstantClick.on) { try { InstantClick.on('change', unlock); } catch (e) {} }
  window.addEventListener('pageshow', unlock);

  /* ---------- Suggestions ---------- */
  function sync() {
    var input = q('[data-bvs-input]'), v = input.value.trim();
    q('[data-bvs-clear]').hidden = !input.value;
    var start = q('[data-bvs-start]'), res = q('[data-bvs-results]');
    if (v.length < MIN) { start.hidden = false; res.innerHTML = ''; res.hidden = true; return; }
    start.hidden = true; res.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(function () { fetchResults(v); }, DELAY);
  }
  function fetchResults(v) {
    var r = root(), res = q('[data-bvs-results]');
    if (cache[v]) { res.innerHTML = cache[v]; return; }
    if (!res.firstChild) res.innerHTML = '<p class="bvs-loading">' + esc(r.getAttribute('data-loading')) + '</p>';
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = r.getAttribute('data-url') + '?q=' + encodeURIComponent(v) +
      '&resources%5Btype%5D=product%2Ccollection%2Cquery&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Ctag' +
      '&section_id=bvn-predictive';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (x) { return x.ok ? x.text() : Promise.reject(x.status); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-bvs-res]');
      if (!el) return;
      cache[v] = el.outerHTML;
      if (q('[data-bvs-input]').value.trim() === v) res.innerHTML = cache[v];
    }).catch(function () {});
  }

  /* ---------- Clics ---------- */
  function opener(t) {
    if (!t || !t.closest) return null;
    return t.closest('[data-bvs-open], .bv-bottomnav a[href$="/search"], a.icon-search');
  }
  document.addEventListener('click', function (e) {
    var o = opener(e.target);
    if (o && root()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
      return;
    }
    if (!isOpen()) return;
    if (e.target.closest('[data-bvs-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-bvs-clear]')) {
      e.preventDefault(); var i = q('[data-bvs-input]'); i.value = ''; sync(); i.focus(); return;
    }
    if (e.target.closest('[data-bvs-recent-clear]')) {
      e.preventDefault(); try { localStorage.removeItem(KEY); } catch (x) {} drawRecent(); return;
    }
    var term = e.target.closest('[data-bvs-term]');
    if (term) addRecent(term.getAttribute('data-bvs-term'));
    var item = e.target.closest('.bvs__panel a[href]');
    if (item) { addRecent(q('[data-bvs-input]').value); document.documentElement.classList.remove('bvs-lock'); }
  }, true);

  document.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bvs-input')) sync(); });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bvs-form]')) return;
    var v = q('[data-bvs-input]').value.trim();
    if (!v) { e.preventDefault(); return; }
    addRecent(v);
  });

  /* ---------- Clavier : Échap, flèches dans les résultats, focus gardé dans le panneau ---------- */
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    var panel = q('.bvs__panel');
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([hidden]), input:not([type=hidden])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var items = Array.prototype.slice.call(panel.querySelectorAll('[data-bvs-results] [data-bvs-item]'));
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      var n = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? -1 : i - 1);
      if (n < 0) q('[data-bvs-input]').focus(); else items[n].focus();
    }
  });
})();
